import { useEffect, useState } from "react";

/**
 * Detect if the app is running on a real mobile device (or native app),
 * not just a resized/emulated desktop browser.
 *
 * Rules:
 * - Native app (Capacitor) => true
 * - Mobile browser => requires BOTH a mobile UA signal AND a touch/coarse-pointer signal
 */
export const useIsActualMobileDevice = () => {
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  useEffect(() => {
    const ua = (navigator.userAgent || "").toLowerCase();

    // Native app detection (Capacitor)
    const isCapacitor =
      ua.includes("capacitor") ||
      (typeof (window as any).Capacitor !== "undefined" &&
        typeof (window as any).Capacitor.isNativePlatform === "function" &&
        (window as any).Capacitor.isNativePlatform());

    // Browser mobile hints
    const uaDataMobile = (navigator as any).userAgentData?.mobile === true;
    const mobileKeywords = [
      "android",
      "iphone",
      "ipad",
      "ipod",
      "webos",
      "blackberry",
      "windows phone",
    ];
    const isMobileUA =
      uaDataMobile ||
      ua.includes("mobile") ||
      mobileKeywords.some((keyword) => ua.includes(keyword));

    // Physical-device hints (prevents desktop UA spoof + responsive preview false positives)
    const hasTouch = (navigator.maxTouchPoints ?? 0) > 0;
    const coarsePointer =
      typeof window !== "undefined" && typeof window.matchMedia === "function"
        ? window.matchMedia("(pointer: coarse)").matches
        : false;
    const noHover =
      typeof window !== "undefined" && typeof window.matchMedia === "function"
        ? window.matchMedia("(hover: none)").matches
        : false;

    const isPhysicalMobileBrowser = isMobileUA && (hasTouch || coarsePointer || noHover);

    setIsMobileDevice(Boolean(isCapacitor || isPhysicalMobileBrowser));
  }, []);

  return isMobileDevice;
};
